export default "__VITE_ASSET__CK4vFfSl__"